/* LD · Pagina del carrito estilo ADOR */
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  class LdCartPage extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var self = this;
      this.timers = {};
      this.addEventListener('click', function (e) {
        var q = e.target.closest('[data-ldcp-qty]');
        if (q) {
          var item = q.closest('.ldCP__item');
          var input = item.querySelector('[data-ldcp-input]');
          var v = Math.max(0, (parseInt(input.value, 10) || 0) + (q.dataset.ldcpQty === 'plus' ? 1 : -1));
          input.value = v;
          clearTimeout(self.timers[item.dataset.key]);
          self.timers[item.dataset.key] = setTimeout(function () { self.change(item, v); }, 350);
          return;
        }
        var rm = e.target.closest('[data-ldcp-remove]');
        if (rm) { e.preventDefault(); self.change(rm.closest('.ldCP__item'), 0); }
      });
      this.addEventListener('change', function (e) {
        var input = e.target.closest('[data-ldcp-input]');
        if (input) self.change(input.closest('.ldCP__item'), Math.max(0, parseInt(input.value, 10) || 0));
      });
      this.addEventListener('submit', function (e) {
        var b = e.target.querySelector('[data-ldcp-checkout]');
        if (b) b.setAttribute('aria-busy', 'true');
      });
      /* Si el carrito cambia desde el carrito lateral, actualizar la pagina */
      document.addEventListener('ld:cart:changed', function (e) { if (!e.detail || !e.detail._fromPage) self.reload(); });
    }

    render(html) {
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-ldcp-root]');
      if (!fresh) return;
      var wasEmpty = this.classList.contains('is-empty');
      var nowEmpty = fresh.classList.contains('is-empty');
      if (wasEmpty !== nowEmpty || nowEmpty) {
        this.className = fresh.className;
        this.querySelector('.ldCP__w').innerHTML = fresh.querySelector('.ldCP__w').innerHTML;
        return;
      }
      ['.ldCP__items', '.ldCP__totals'].forEach(function (sel) {
        var a = this.querySelector(sel), b = fresh.querySelector(sel);
        if (a && b) a.innerHTML = b.innerHTML;
      }, this);
      var oc = this.querySelector('.ldCP__cdisc'), nc = fresh.querySelector('.ldCP__cdisc');
      if (oc && !nc) oc.remove();
      else if (nc && oc) oc.innerHTML = nc.innerHTML;
      else if (nc && !oc) this.querySelector('.ldCP__blocks').insertAdjacentElement('afterbegin', nc);
    }

    reload() {
      var self = this;
      return fetch(window.location.pathname + '?section_id=' + this.dataset.section)
        .then(function (r) { return r.text(); })
        .then(function (html) { self.render(html); })
        .catch(function () {});
    }

    change(item, qty) {
      var self = this;
      if (!item) return;
      clearTimeout(this.timers[item.dataset.key]);
      item.classList.add('is-loading');
      var err = item.querySelector('[data-ldcp-err]');
      if (err) err.textContent = '';
      var sections = [this.dataset.section];
      if (document.querySelector('ld-cart-drawer')) sections.push('ld-cart-drawer');
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.dataset.key, quantity: qty, sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            var msg = res.j.description || res.j.message || '';
            return self.reload().then(function () {
              var again = self.querySelector('.ldCP__item[data-key="' + item.dataset.key + '"] [data-ldcp-err]');
              if (again) again.textContent = msg;
            });
          }
          var s = res.j.sections || {};
          if (s[self.dataset.section]) self.render(s[self.dataset.section]); else self.reload();
          var drawer = document.querySelector('ld-cart-drawer');
          if (drawer && s['ld-cart-drawer'] && typeof drawer.render === 'function') drawer.render(s['ld-cart-drawer']);
        })
        .catch(function () { item.classList.remove('is-loading'); });
    }
  }

  if (!customElements.get('ld-cart-page')) customElements.define('ld-cart-page', LdCartPage);
})();
